import { render, staticRenderFns } from "./mediateList_center.vue?vue&type=template&id=7208d270&scoped=true&"
import script from "./mediateList_center.vue?vue&type=script&lang=js&"
export * from "./mediateList_center.vue?vue&type=script&lang=js&"
import style0 from "./mediateList_center.vue?vue&type=style&index=0&id=7208d270&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7208d270",
  null
  
)

export default component.exports